import React from 'react';
import { FormattedMessage } from 'react-intl';
import { RateShopper as RateShopperActionableFilterPill } from '../../../../components/actionable-filter-pill/connected/orders/rate-shopper';
import { SERVICE_COLLECTION } from '../../../../filters/constants';
import { apiKey } from '../../../../filters/options/service-collection';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service';
import { messages } from './messages';

export const RateShopper = {
  id: SERVICE_COLLECTION,
  displayName: <FormattedMessage {...messages.rateShopper} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: apiKey,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },

  allowsMultipleSelection: true,
  expectsArgumentAsArray: true,
  shouldHideActionButtons: true,
  actionableFilterPill: RateShopperActionableFilterPill,
};
